<template>
  <div class="no-padding no-margin">
      <Table v-if="route==`/superadmin/providers`"></Table>
      <AddNewForm v-if="route==`/superadmin/providers/add-new`"></AddNewForm> 
      <SingleForm v-if="route==`/superadmin/providers/provider`"></SingleForm>
      <InviteForm  v-if="route==`/superadmin/providers/invite-provider`"></InviteForm>
  </div>
    
</template>
<script>
import Table from './ProvidersTable.vue'
import SingleForm from './SingleProvider.vue'
import AddNewForm from './AddProvider.vue'
import InviteForm from './InviteProviders.vue'
// getPath

export default{
  data(){
    return{
        
    }
  },
  created(){
  },
  computed:{
     route(){
        return this.$route.path;
      },
      routeParams(){
        let parsed =''
        if(this.$route.params.name){
          parsed = this.$route.params.name.replace(/ /g, '%20')
        }
        return parsed
      }
  },
  methods:{

  },
  components:{
        SingleForm,
        AddNewForm,
        Table,
        InviteForm
 
  }
}

</script>
